<template>
  <div class="metadata-value d-flex flex-column min-w-0">
    <div
      v-for="metadataItem in metadataItems"
      :key="metadataItem.value"
      class="d-flex justify-content-between align-items-center i-gap-4"
    >
      <span class="min-w-0">
        <div
          v-if="Array.isArray(metadataItem.value)"
          class="d-flex flex-column min-w-0"
        >
          <span v-for="item in metadataItem.value" :key="item">
            {{ metadataValue(item) }}
          </span>
        </div>
        <span v-else> {{ metadataValue(metadataItem.value) }}</span>
      </span>
      <i-badge
        v-if="metadataItems.length > 1"
        class="i-mt-1"
        :label="metadataItem.type"
      ></i-badge>
    </div>
  </div>
</template>

<script>
import { displayMetadataValue } from '@/utils/metadata';
import { iBadge } from '@inscribe/signal';

export default {
  components: { iBadge },
  props: {
    metadataItems: {
      type: Array,
      required: true,
    },
  },
  methods: {
    metadataValue: displayMetadataValue,
  },
};
</script>
